"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressLayer = void 0;
const UiElements_1 = require("../ui/UiElements");
const BaseLayer_1 = require("./BaseLayer");
class ProgressLayer extends BaseLayer_1.BaseLayer {
    constructor(className) {
        super(className);
        this._visible = true;
        this.playIcon = this.createPlayIcon();
        this.loadIcon = this.createLoadIcon();
        this.loadText = this.createLoadText();
        this.backFog = this.createBackFog();
        this.loader = this.createLoader();
        this.loader.addChild(this.playIcon);
        this.loader.addChild(this.loadIcon);
        this.loader.addChild(this.loadText);
        this.container.addChild(this.backFog);
        this.container.addChild(this.loader);
        this.stopLoader();
    }
    get visible() { return this._visible; }
    set visible(visible) {
        this.container.domEl.style.display = visible ? 'inline' : 'none';
        this._visible = visible;
    }
    startLoader() {
        this.playIcon.setDisplay('none');
        this.loadIcon.setDisplay('');
        this.loadText.setDisplay('');
    }
    stopLoader() {
        this.loadIcon.setDisplay('none');
        this.loadText.setDisplay('none');
        this.playIcon.setDisplay('');
    }
    createBackFog() {
        return new UiElements_1.DivEl()
            .setClass('back-fog');
    }
    createLoader() {
        return new UiElements_1.DivEl()
            .setClass('loader')
            .setId('loader');
    }
    createPlayIcon() {
        return new UiElements_1.IconEl('ci ci-play');
    }
    createLoadIcon() {
        return new UiElements_1.SpanEl()
            .setClass("spinner-border")
            .addAttribute('role', 'status')
            .addAttribute('aria-hidden', 'true')
            .setStyle({ 'width': '5rem', 'height': '5rem' });
    }
    createLoadText() {
        return new UiElements_1.HeadingEl('h5')
            .setDisplay('none')
            .addChild(new UiElements_1.SpanEl()
            .addAttribute('data-i18n-key', 'LOADING_MESSAGE_TITLE')
            .setStyle({ 'font-size': '1.5rem' }))
            .addChild(new UiElements_1.SpanEl()
            .addAttribute('data-i18n-key', 'LOADING_MESSAGE_TEXT')
            .setStyle({
            'display': 'block',
            'font-size': '1rem',
            'padding-top': '1rem',
        }));
    }
}
exports.ProgressLayer = ProgressLayer;
